import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TERMS_OF_SERVICE_URL = 'https://legal.hubspot.com/checkout-termsofuse';
const PRIVACY_POLICY_URL = 'https://legal.hubspot.com/privacy-policy';
const HubSpotTermsOfServiceFooter = () => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "hubspot-terms-of-service",
    children: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      paddingBlockStart: "1000",
      children: /*#__PURE__*/_jsxs(Text, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.hubspotTermsOfService.managedByHubSpot"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.hubspotTermsOfService.terms_jsx",
          options: {
            termsUrl: TERMS_OF_SERVICE_URL
          },
          elements: {
            Link
          }
        }), ' | ', /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.hubspotTermsOfService.privacyPolicy_jsx",
          options: {
            privacyPolicyUrl: PRIVACY_POLICY_URL
          },
          elements: {
            Link
          }
        })]
      })
    })
  });
};
export default HubSpotTermsOfServiceFooter;